<span [style.background-color]="priority().color" class="inline-block p-1 text-sm font-semibold rounded-full">

@switch (priority().id) {
  @case (priorityEnum.HIGH) {
    <elcia-icon [iconSize]="'xs'" [iconType]="'top-right-arrow'"/>
  }
  @case (priorityEnum.MEDIUM) {
    <elcia-icon [iconSize]="'xs'" [iconType]="'right-arrow'"/>
  }
  @case (priorityEnum.LOW) {
    <elcia-icon [iconSize]="'xs'" [iconType]="'bottom-right-arrow'"/>
  }
  @case (priorityEnum.UNDEFINED) {
    <elcia-icon [iconSize]="'xs'" [iconType]="'minus'"/>
  }
}
</span>
